import React, { useEffect } from 'react';
import { Box, Grid } from '@material-ui/core';
import { createStructuredSelector } from 'reselect';
import { isEmpty } from 'lodash';
import Modal from 'components/Modal';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { SizedLongBody } from 'containers/SignupPages/PersonalInfo/styles';
import { translate } from 'helpers/intl';
import messages from 'containers/AUTODashboard/messages';
import {
  StyledShortBody,
  StyledLink,
} from 'containers/MRhDashboard/services/styles';
import { sanlamDarkGrayishBlue } from 'Material-UI/colors';
import {
  openModalServicesAuto,
  closeModalServicesAuto,
} from 'store/global/actions';
import { contactAuto } from 'utils/globalConst';
import { StyledBodyText } from 'components/ModalServices/ModalServicesAuto/styles';
import { OrangeButton } from 'components/Button';
import ChevronCardButton from 'components/ChevronCardButton';
import { sanlamVeryLightgray } from 'Material-UI/colors';
import {
  StyledGrid,
  StyledGridLeft,
} from 'components/ModalServices/ModalServicesAuto/styles';
import { getAgents } from 'store/geolocAgent/actions';
import { IntlShape } from 'react-intl';
import { getAgentSelector } from 'store/geolocAgent/selectors';
import { useSelector } from 'react-redux';
import { isReverse } from 'helpers/intl';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { reversedNum } from 'utils/string';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';

const ModalServicesAuto = ({
  openModalServicesAuto,
  closeModalServicesAuto,
  isOpen,
  getAgents,
  agentInfo,
  ...props
}: {
  intl: IntlShape;
  openModalServicesAuto: Function;
  closeModalServicesAuto: Function;
  isOpen: Boolean;
  agentInfo: { FAX: string; AGT_EMAIL: string };
  getAgents: Function;
}) => {
  useEffect(() => {
    getAgents();
  }, [getAgents]);
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const items = [
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.AUTO_ACCEUIL}
          label="Que faire en cas de sinistre ? 3434"
        >
          <StyledLink href={`tel:${contactAuto.service}`}>
            <Grid container direction="row">
              <Grid>
                <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
                  {translate(messages.contactAgentService, props)}
                </StyledShortBody>
              </Grid>
              <StyledGridLeft reverse={reverse}>
                <StyledShortBody color="#003FCB" weight="500">
                  {contactAuto.service}
                </StyledShortBody>
              </StyledGridLeft>
            </Grid>
          </StyledLink>
        </GaClickHOC>
      ),
      icon: 'CallServiceAuto',
    },
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.AUTO_ACCEUIL}
          label="Que faire en cas de sinistre ? Contacter mon agent"
        >
          <StyledLink href={`tel:${agentInfo && agentInfo.FAX}`}>
            <Grid container direction="row">
              <Grid>
                <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
                  {translate(messages.contactAgent, props)}
                </StyledShortBody>
              </Grid>
              <StyledGridLeft reverse={reverse}>
                <StyledShortBody color="#003FCB" weight="500">
                  {agentInfo && reverse
                    ? reversedNum(agentInfo.FAX)
                    : agentInfo && agentInfo.FAX}
                </StyledShortBody>
              </StyledGridLeft>
            </Grid>
          </StyledLink>
        </GaClickHOC>
      ),
      icon: 'AgentCallAuto',
    },
    {
      title: (
        <GaClickHOC
          category={EVENT_CATEGORIES.AUTO_ACCEUIL}
          label="Que faire en cas de sinistre ? Contacter par email"
        >
          <Grid>
            <StyledShortBody color={sanlamDarkGrayishBlue} weight="500">
              {translate(messages.contactEmail, props)}
            </StyledShortBody>
          </Grid>
        </GaClickHOC>
      ),
      icon: 'AgentEmailAuto',
    },
  ];
  return (
    <>
      <Modal
        open={isOpen}
        handleOpen={openModalServicesAuto}
        handleClose={closeModalServicesAuto}
        header={
          <SizedLongBody weight="500" color="#04336B">
            {translate(messages.declarer_Sinistre, props)}
          </SizedLongBody>
        }
        content={
          <>
            <Box paddingX={2}>
              <SizedLongBody weight="500" color="#04336B">
                {translate(messages.declarer_Sinistre_title, props)}
              </SizedLongBody>
              <StyledBodyText weight="300">
                {translate(messages.declarer_Sinistre_description, props)}
              </StyledBodyText>
              <Box marginTop={3} marginBottom={3}>
                {
                  /* istanbul ignore next */
                  agentInfo && isEmpty(agentInfo.FAX) ? (
                    <StyledGrid container spacing={3}>
                      {items
                        .filter((item: any) => item.icon !== 'AgentCallAuto')
                        .map((item: any, index: number) => (
                          <Grid item xs={12} key={index}>
                            <ChevronCardButton
                              borderColor={sanlamVeryLightgray}
                              item={item}
                              clickHandler={() =>
                                index === 2
                                  ? window.open(
                                      `mailto:${agentInfo.AGT_EMAIL}`,
                                      '_blank',
                                    )
                                  : null
                              }
                              deleteHoverBorder={true}
                            />
                          </Grid>
                        ))}
                    </StyledGrid>
                  ) : agentInfo && isEmpty(agentInfo.AGT_EMAIL) ? (
                    <StyledGrid container spacing={3}>
                      {items
                        .filter((item: any) => item.icon !== 'AgentEmailAuto')
                        .map((item: any, index: number) => (
                          <Grid item xs={12} key={index}>
                            <ChevronCardButton
                              borderColor={sanlamVeryLightgray}
                              item={item}
                              clickHandler={() =>
                                index === 2
                                  ? window.open(
                                      `mailto:${agentInfo.AGT_EMAIL}`,
                                      '_blank',
                                    )
                                  : null
                              }
                              deleteHoverBorder={true}
                            />
                          </Grid>
                        ))}
                    </StyledGrid>
                  ) : (
                    <StyledGrid container spacing={3}>
                      {items.map((item: any, index: number) => (
                        <Grid item xs={12} key={index}>
                          <ChevronCardButton
                            borderColor={sanlamVeryLightgray}
                            item={item}
                            clickHandler={() =>
                              index === 2
                                ? window.open(
                                    `mailto:${agentInfo.AGT_EMAIL}`,
                                    '_blank',
                                  )
                                : null
                            }
                            deleteHoverBorder={true}
                          />
                        </Grid>
                      ))}
                    </StyledGrid>
                  )
                }
              </Box>
            </Box>
          </>
        }
        footer={
          <Grid container justify="flex-end">
            <Grid item>
              <OrangeButton
                variant="contained"
                onClick={closeModalServicesAuto}
              >
                {translate(messages.close, props)}
              </OrangeButton>
            </Grid>
          </Grid>
        }
      ></Modal>
    </>
  );
};
const mapStateToProps = createStructuredSelector<
  any,
  {
    agentInfo: { FAX: string; AGT_EMAIL: string };
  }
>({
  agentInfo: getAgentSelector,
});
const mapDispatchToProps = {
  openModalServicesAuto,
  closeModalServicesAuto,
  getAgents,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ModalServicesAuto));
